import { render, staticRenderFns } from "./mega_menu_dynamic_dropdown.vue?vue&type=template&id=48c59486"
import script from "./mega_menu_dynamic_dropdown.vue?vue&type=script&lang=js"
export * from "./mega_menu_dynamic_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Search: require('/home/ubuntu/containers/hermes_eshop/components/core/search.vue').default,HyperLink: require('/home/ubuntu/containers/hermes_eshop/components/core/hyperLink.vue').default})
